
<!-- Sidebar  -->
<div id="custom-nav" class="active collapse d-md-block">

   <div class="home menu-item">
      <a class="bbtn" id="dashboard" href="javascript:void(0)" [routerLink]="['/dashboard']" (click)="selectMe($event)" routerLinkActive="active">
         <span>Home</span>
      </a>
   </div>         
            <!-- <a href="javascript:void(0)" [routerLink]="['/ticket']" (click)="selectMe($event)" routerLinkActive="active">
               <i class="fa fa-book"></i>
               Employee Handbook
            </a> -->
   <div class="ask menu-item" >
      <a class="bbtn" id="askanattorney" href="javascript:void(0)" [routerLink]="['/ticket']" (click)="selectMe($event)" routerLinkActive="active">
         <span>Ask an Attorney</span>
      </a>
   </div>

   <div class="employees menu-item" *ngIf="showEmployees">
      <a class="bbtn" id="employees" href="javascript:void(0)" [routerLink]="['/employees']" (click)="selectMe($event)" routerLinkActive="active">
         <span>Employees</span>
      </a>
   </div>

   <div class="solution menu-item">
      <a id="solution-center" class="bbtn" href="javascript:void(0)" [routerLink]="['/hr-menu/solution-center']" routerLinkActive="active" (click)="selectMe($event)">
         <span>HR Solutions Center</span>
      </a>
   </div>
   <div class="solution-center menu-item">
      <ng-container *ngFor="let page of hrPages">
         <a  class="sub-bbtn" id="sc-page{{page.ID}}" href="javascript:void(0)" [routerLink]="['/hr-menu/solution-center',page.ID]" routerLinkActive="active" (click)="selectMe($event)">
            <span>{{page.Name}}</span>
         </a> 
      </ng-container>
      
   </div>


   <div class="business menu-item">
      <a id="biz-menu" class="bbtn" href="javascript:void(0)" [routerLink]="['/hr-menu/business-center']" routerLinkActive="active" (click)="selectMe($event)">
         <span>Business Center</span>
      </a>
   </div>
   <div class="business-center menu-item">

      <ng-container *ngFor="let page of proPages">
         <a  class="sub-bbtn" id="pro-page{{page.ID}}" href="javascript:void(0)" [routerLink]="['/hr-menu/business-center',page.ID]" routerLinkActive="active" (click)="selectMe($event)">
            <span>{{page.Name}}</span>
         </a> 
      </ng-container>

   </div>


   <div class="erisa menu-item" *ngIf="showErisa">
      <a id="erisa-menu" class="bbtn" href="javascript:void(0)" [routerLink]="['/hr-menu/erisa-center']" routerLinkActive="active" (click)="selectMe($event)">
         <span>ERISA Center</span>
      </a>
   </div>
   <div class="erisa-center menu-item">

      <ng-container *ngFor="let page of erisaPages">
         <a  class="sub-bbtn" id="erisa-page{{page.ID}}" href="javascript:void(0)" [routerLink]="['/hr-menu/erisa-center',page.ID]" routerLinkActive="active" (click)="selectMe($event)">
            <span>{{page.Name}}</span>
         </a> 
      </ng-container>

   </div>



   <div class="admin menu-item" *ngIf="userSer.isAdmin() || userSer.isPartner()">
      <a class="bbtn" id="admin-sidebar" href="javascript:void(0)" [routerLink]="['/admins/admin-menu']" (click)="selectMe($event)" routerLinkActive="active">
         <span>System Admin</span>
      </a>
   </div>

   <!-- 
            <a href="javascript:void(0)" [routerLink]="['/biz-menu']"  (click)="selectMe($event)">
               <i class="fa fa-gavel"></i>
               Business Center
            </a>

            <a class="active" id="admin-menu"
                  href="javascript:void(0)" [routerLink]="['/admins/admin-menu']" 
                  (click)="selectMe($event)">
                  <i class="fa fa-copy"></i>
                  Settings
            </a>
         </li>
      </ul> -->

   </div>





            <!-- <ul class="collapse list-unstyled" id="pageSubmenu">
                  <li>
                     <a *ngIf="userSer.isAdmin( permissionData.UserType )" 
                        href="javascript:void(0)" [routerLink]="['/admins/admin-menu']" routerLinkActive="active">
                        <i class="fa fa-user"></i>
                        Users
                     </a>
                  </li>
                  <li>
                     <a *ngIf="userSer.isAdmin( permissionData.UserType )" 
                        href="javascript:void(0)" [routerLink]="['/admins/client-list']" routerLinkActive="active">
                        <i class="fa fa-building"></i>
                        Clients
                     </a>
                  </li>
                  <li>
                     <a *ngIf="userSer.isAdmin( permissionData.UserType )" 
                        href="javascript:void(0)" [routerLink]="['/admins/partner-list']" routerLinkActive="active">
                        <i class="fa fa-address-book"></i>
                        Partners
                     </a>                      
               </li>
            </ul> -->
